import { isBullpen } from "application/platformConfiguration";

export const dataRoomText = isBullpen()
  ? {
      TITLE: "Data Sources",
      PERMISSIONS_CRUMB: "Data sources",
    }
  : {
      TITLE: "Data Room",
      PERMISSIONS_CRUMB: "Data room",
    };
